import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import gql from 'graphql-tag';
import { ref } from 'vue';
import { useRouter } from "vue-router";
import { useSearchAutoComplete } from '@/composables/useSearchAutoComplete'
import { AutoCompleteItemSelectEvent } from 'primevue/autocomplete';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { onResult, suggestions, onComplete } = useSearchAutoComplete(gql`
   query SearchTags($search: String!) {
     search_tags(args: {search: $search}) {
       name
       post_tags_aggregate {
         aggregate {
           count
         }
       }
     }
   }`
)

const router = useRouter();

const selectedTag = ref();

onResult(({ data: { search_tags } }) => {
  suggestions.value = search_tags
})

const onItemSelect = (event: AutoCompleteItemSelectEvent) => {
  const { name } = event.value;
  router.push(`/tags/${encodeURIComponent(name)}`);
}

return (_ctx: any,_cache: any) => {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createBlock(_component_AutoComplete, {
    modelValue: selectedTag.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTag).value = $event)),
    suggestions: _unref(suggestions),
    onComplete: _cache[1] || (_cache[1] = ($event: any) => (_unref(onComplete)($event))),
    field: "name",
    onItemSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push(`/tags/${encodeURIComponent($event.value.name)}?p=1`))),
    class: "mr-2",
    placeholder: "Search for tags"
  }, {
    item: _withCtx((slotProps) => [
      _createElementVNode("div", null, [
        _createTextVNode(_toDisplayString(slotProps.item.name) + " ", 1),
        _createElementVNode("small", null, "(" + _toDisplayString(slotProps.item.post_tags_aggregate.aggregate.count) + ")", 1)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "suggestions"]))
}
}

})